var map = {
	"./android-qr-code.png": 8385,
	"./background-image.svg": 2744,
	"./backspace.svg": 6614,
	"./blood-pressure-dark-green.svg": 3332,
	"./blood-pressure.svg": 5897,
	"./checkmark.svg": 1673,
	"./coffee_photos/FWD_AJ.png": 5178,
	"./coffee_photos/FWD_Cap.png": 9060,
	"./coffee_photos/FWD_EarlGrey.png": 6670,
	"./coffee_photos/FWD_EnglishBreakfastTea.png": 5767,
	"./coffee_photos/FWD_HotBlack.png": 9922,
	"./coffee_photos/FWD_IcedBlack.png": 2583,
	"./coffee_photos/FWD_IcedLatte.png": 2217,
	"./coffee_photos/FWD_Jasmine.png": 8363,
	"./coffee_photos/FWD_Latte.png": 361,
	"./coffee_photos/FWD_OJ.png": 3531,
	"./colour-star.svg": 3119,
	"./crossmark.svg": 2201,
	"./dropdown-close.svg": 5864,
	"./dummy-coffee.png": 4561,
	"./email-icon-white.svg": 3901,
	"./email-icon.svg": 5124,
	"./face-animation": 5200,
	"./face-animation.json": 5200,
	"./face-id.svg": 2675,
	"./fwd-icon.svg": 8155,
	"./grey-star.svg": 493,
	"./icon.gif": 9245,
	"./ios-qr-code.png": 2825,
	"./label.png": 8221,
	"./left-arrow-icon.svg": 6037,
	"./loading.gif": 3612,
	"./panoptic_ai.svg": 7144,
	"./panoptic_ai_vitals.png": 1328,
	"./qr-placeholder.svg": 6460,
	"./report.svg": 9086,
	"./silhouette.png": 2879,
	"./skin-age-dark-green.svg": 177,
	"./skin-age.svg": 8818,
	"./spinner.svg": 4418,
	"./stress-dark-green.svg": 7911,
	"./stress.svg": 4220,
	"./survey-qr.png": 9206,
	"./switch-camera.svg": 8540,
	"./time-spinner-orange.svg": 7494,
	"./time-spinner.svg": 3105,
	"./wechat-icon.svg": 2053,
	"./wechat-qr-code.png": 9085,
	"./wellness.svg": 4383,
	"./whatsapp-icon.svg": 4958
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3254;